const t = "_wrapper_1ye8b_2", n = "_dialogContent_1ye8b_6", o = "_actionArea_1ye8b_11", e = "_actionAreaInDialog_1ye8b_15", a = "_listSection_1ye8b_22", i = "_input_1ye8b_25", _ = {
  wrapper: t,
  dialogContent: n,
  actionArea: o,
  actionAreaInDialog: e,
  listSection: a,
  input: i
};
export {
  o as actionArea,
  e as actionAreaInDialog,
  _ as default,
  n as dialogContent,
  i as input,
  a as listSection,
  t as wrapper
};
